import axios from 'axios';
import { clearLocalStorage } from "../utils/helpers";
import stopReload from "../constants/Constants";


export const api = axios.create({
  baseURL: `${__CLOUD_SERVER__}`,
  headers: {
    "Accept": "application/json",
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  request => {
    request.data.token = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).token; 
    request.data.username = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).username;

    if (request.url === 'new_session_token') {
      // return early if its a call to new_session_token as we don't want to reset the timeout every 5 minutes
      return request
    }

    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { window.localStorage.setItem("unActiveStateSec", new Date().getTime()); }

    return request
  }
);

api.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if ('error_message' in response.data) { // handles cases where status 200 is actually a failure, should be fixed in an API update
        if (response.data.error_message === 'Access Denied') { // handles case when token gets expired
          if ('reason' in response.data && response.data.reason === 'expired_password') {
            return response.data
          }
          clearLocalStorage();
          window.removeEventListener("beforeunload", stopReload, true);
          window.location.reload();
        }
      }
      return response.data
    } else {
      return Promise.reject({ status: response.status, error: response.status + ' Invalid request', body: response.data });
    }
    
  },
  error => {
    return Promise.reject({ status: error.response.status, error: error.message, body: error.response.data });
  }
);
  